import memoize from 'memoize-one';

export const sortSectors = memoize(sectors => sectors.sort((a, b) => a.name.localeCompare(b.name)));
